var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { remoteJobRunsApi, remoteJobsApi } from '@data/rest/api';
import { RemoteJobStatus } from '@common/api';
var QUERY_KEY_REMOTE_JOBS = ['remoteJobs'];
var QUERY_KEY_REMOTE_JOB_RUNS = ['remoteJobRuns'];
export function useRemoteJobs() {
    var data = useQuery(QUERY_KEY_REMOTE_JOBS, function () { return remoteJobsApi.list(); }, {
        refetchInterval: 5000,
    }).data;
    return data !== null && data !== void 0 ? data : [];
}
export function useRemoteJobActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var remove = useMutation(function (id) { return remoteJobsApi._delete(id); }, {
        onSettled: function () {
            queryClient.invalidateQueries(QUERY_KEY_REMOTE_JOBS);
        },
    });
    var run = useMutation(function (_a) {
        var remoteJobId = _a.remoteJobId, jobArguments = _a.jobArguments;
        return remoteJobsApi.run(remoteJobId, { arguments: jobArguments });
    }, {
        onMutate: function (_a) {
            var remoteJobId = _a.remoteJobId, jobArguments = _a.jobArguments;
            return __awaiter(_this, void 0, void 0, function () {
                var previousRemoteJobs, newRemoteJobs, previousRemoteJobs_1, previousRemoteJobs_1_1, rj;
                var e_1, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(QUERY_KEY_REMOTE_JOBS)];
                        case 1:
                            _c.sent();
                            previousRemoteJobs = queryClient.getQueryData(QUERY_KEY_REMOTE_JOBS);
                            if (previousRemoteJobs !== undefined) {
                                newRemoteJobs = [];
                                try {
                                    for (previousRemoteJobs_1 = __values(previousRemoteJobs), previousRemoteJobs_1_1 = previousRemoteJobs_1.next(); !previousRemoteJobs_1_1.done; previousRemoteJobs_1_1 = previousRemoteJobs_1.next()) {
                                        rj = previousRemoteJobs_1_1.value;
                                        if (rj.id === remoteJobId) {
                                            newRemoteJobs.push(__assign(__assign({}, rj), { status: RemoteJobStatus.QUEUED }));
                                        }
                                        else {
                                            newRemoteJobs.push(rj);
                                        }
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (previousRemoteJobs_1_1 && !previousRemoteJobs_1_1.done && (_b = previousRemoteJobs_1.return)) _b.call(previousRemoteJobs_1);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                                queryClient.setQueryData(QUERY_KEY_REMOTE_JOBS, newRemoteJobs);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        onSettled: function (data, error, _a) {
            var remoteJobId = _a.remoteJobId, jobArguments = _a.jobArguments;
            queryClient.invalidateQueries([QUERY_KEY_REMOTE_JOB_RUNS, remoteJobId]);
        },
    });
    return {
        removeRemoteJob: remove.mutateAsync,
        runRemoteJob: run.mutateAsync,
    };
}
export function useRemoteJobRunsByRemoteJobId(remoteJobId) {
    var data = useQuery([QUERY_KEY_REMOTE_JOB_RUNS, remoteJobId], function () { return remoteJobRunsApi.listByRemoteJobId(remoteJobId); }, { refetchInterval: 2000, enabled: remoteJobId !== 0 }).data;
    return data !== null && data !== void 0 ? data : [];
}
